import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { PlessBlockLayerService } from './pless-block-layer.service';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';

/**
 * Httpをラップするクラス。通信共通の処理を実装する際はここに記述する
 */
@Injectable()
export class PlessHttp {

  constructor(private http: HttpClient, private blockLayerService: PlessBlockLayerService) { }

  /**
   * POSTで通信
   */
  post<T>(url: string, body: any, options?: { headers: HttpHeaders, responseType: 'text' | 'json', withCredentials: boolean }): Observable<HttpResponse<T>> {
    const opt = options || {};
    return this.http.post<T>(url, body, { ...opt, observe: 'response'});
  }

  /**
   * GETで通信
   */
  get<T>(url: string, options?: { headers: HttpHeaders, responseType: 'text' | 'json', withCredentials: boolean }): Observable<HttpResponse<T>> {
    const opt = options || {};
    return this.http.get<T>(url, { ...opt, observe: 'response'});
  }

  /**
   * 操作禁止の為のレイヤーを作成
   */
  createBlockLayer() {
    this.blockLayerService.createBlockLayer();
  }

  /**
   * 操作禁止の為のレイヤーを削除
   */
  removeBlockLayer() {
    this.blockLayerService.removeBlockLayer();
  }
}
